// @flow

export const FullPageSignupToggleType = {
  DEFAULT_TOGGLE: 'DEFAULT_TOGGLE',
  NO_TOGGLE: 'NO_TOGGLE',
  SMALL_TOGGLE: 'SMALL_TOGGLE',
  NOT_NOW_BUTTON: 'NOT_NOW_BUTTON',
};

export type FullPageSignupToggle = $Keys<typeof FullPageSignupToggleType>;

export default undefined;
